import { defineField, defineType } from 'sanity'

import getPageInfo, { seoGroup } from '../../objects/pageInfo'

export default defineType({
  title: 'Project',
  name: 'project',
  type: 'document',
  groups: [
    {
      name: 'content',
      title: 'Content',
      default: true,
    },
    seoGroup,
  ],
  fields: [
    defineField({
      title: 'Before Countdown Content',
      name: 'beforeCountdown',
      type: 'beforeCountdown',
      group: 'content',
    }),
    defineField({
      title: 'After Countdown Content',
      name: 'afterCountdown',
      type: 'afterCountdown',
      group: 'content',
    }),
    getPageInfo({ lockCanonical: true }),
  ],
  preview: {
    select: {
      pageInfo: 'pageInfo',
    },
    prepare(selection) {
      const { title = 'New Page', description: subtitle = '' } =
        selection.pageInfo || {}
      return {
        title,
        subtitle,
      }
    },
  },
})